import * as React from "react";
import { Button, MenuItem, Select } from "@material-ui/core";
import { RewardTypes } from "common/constants/RewardTypes";
import { useEventManagerStyles } from "./eventManagerStyles";

export default function DetailsTab({ event, draft, onChange, onSave }) {
	const classes = useEventManagerStyles();

	return (
		<>
			<div className={classes.fields}>
				<label className={classes.rowLabel}>Name</label>
				<input
					className={classes.input}
					value={draft.name}
					placeholder={event.name}
					maxLength={100}
					onChange={(e) => onChange({ name: e.target.value })}
				/>
				<label className={classes.rowLabel}>Image</label>
				<input
					className={classes.input}
					value={draft.image}
					onChange={(e) => onChange({ image: e.target.value })}
				/>
				<label className={classes.rowLabel}>Reward type</label>
				<Select
					className={classes.rewardSelect}
					value={draft.rewardTypeId}
					onChange={(e) => onChange({ rewardTypeId: e.target.value })}
					color="primary"
					displayEmpty
				>
					<MenuItem value="">None</MenuItem>
					{Object.keys(RewardTypes.getRewardTypes(event.gameId)).map((key) => (
						<MenuItem key={RewardTypes[key]} value={RewardTypes[key]}>
							{key}
						</MenuItem>
					))}
				</Select>
			</div>
			<div className={classes.saveRow}>
				<Button
					variant="contained"
					color="primary"
					onClick={() =>
						onSave({
							nameOverride: draft.name,
							image: draft.image,
							rewardTypeId: draft.rewardTypeId,
						})
					}
				>
					Save
				</Button>
			</div>
		</>
	);
}
